<script lang="ts" setup></script>
<template>
  <svg width="50" height="48" viewBox="0 0 50 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="50" height="38" rx="3" fill="currentColor" />
    <rect y="40" width="11" height="8" rx="2" fill="currentColor" />
    <rect x="13" y="40" width="11" height="8" rx="2" fill="currentColor" />
  </svg>
</template>
